/**
 * Wizard gifts stay in the cart only while a Forever Food plan line is still there.
 * Gift quantity stays at the amount the wizard added.
 */
(function () {
  var GIFT_VARIANTS = {
    '58584639537416': true,
    '58724667097352': true,
    '58724644520200': true,
    '58163254657288': true
  };
  var SHARED_GIFT_CODES = {
    'FREEEXTRA-W4': true,
    'GRATISEXTRA-W4': true
  };
  var GIFT_CODES = {
    W4GL: '58584639537416',
    'FREELAMB-W4': '58584639537416',
    'GRATISLAM-W4': '58584639537416',
    W4GD: '58724667097352',
    'FREEDUCK-W4': '58724667097352',
    'GRATISEEND-W4': '58724667097352',
    W4GB: '58724644520200',
    'FREEBEEF-W4': '58724644520200',
    'GRATISRUND-W4': '58724644520200',
    W4GO: '58163254657288',
    'FREESARDINE-W4': '58163254657288',
    'GRATISSARDINE-W4': '58163254657288'
  };
  var W3_GIFT_CODES = {
    W3GIFT: true,
    'FREEGIFT-W3': true,
    'GRATISCADEAU-W3': true
  };
  var WIZARD_CODES = {
    W3: true,
    W3GIFT: true,
    W3S: true,
    '50OFF-W3': true,
    '50KORTING-W3': true,
    'FREESHIPPING-W3': true,
    'GRATISVERZENDING-W3': true,
    'FREEGIFT-W3': true,
    'GRATISCADEAU-W3': true,
    'FREESAMPLE-W3': true,
    'GRATISPROEF-W3': true,
    W4: true,
    W4L: true,
    W4S: true,
    W4GL: true,
    W4GD: true,
    W4GB: true,
    W4GO: true,
    '25OFF-W4': true,
    '25KORTING-W4': true,
    '35OFF-W4': true,
    '35KORTING-W4': true,
    'FREESHIPPING-W4': true,
    'GRATISVERZENDING-W4': true,
    'FREELAMB-W4': true,
    'GRATISLAM-W4': true,
    'FREEDUCK-W4': true,
    'GRATISEEND-W4': true,
    'FREEBEEF-W4': true,
    'GRATISRUND-W4': true,
    'FREESARDINE-W4': true,
    'GRATISSARDINE-W4': true,
    'FREEEXTRA-W4': true,
    'GRATISEXTRA-W4': true,
    'FREESAMPLE-W4': true,
    'GRATISPROEF-W4': true,
    SUB10: true,
    // PLAN10 is the buybox 10%. Leave it off this list so the cart keeps it.
    W5S: true,
    'FREESHIPPING-W5': true,
    'GRATISVERZENDING-W5': true,
    'FREESAMPLE-W5': true,
    'GRATISPROEF-W5': true,
    BULK5: true,
    BULK10: true
  };
  var W3_GIFT_VARIANTS = {
    '58584639537416': true,
    '58724644520200': true,
    '58724667097352': true,
    '58163254657288': true
  };
  var JOURNEYS = { w3: true, w4: true, w5: true };
  var FOOD_PRODUCTS = {
    '10659607675144': true,
    '12311062544648': true,
    '12306597150984': true,
    '12311298638088': true
  };
  var BUYBOX_FREEBIES = {
    '54147127148808': true,
    '58329766461704': true
  };
  var BUYBOX_CODES = {
    PLAN10: true,
    'RUNDKORTING-W4': true,
    'BEEFOFF-W4': true
  };
  var busy = false;
  var snapshot = null;
  var originalFetch = window.fetch;

  function propsOf(item) {
    var props = item && item.properties;
    if (!props) return {};
    if (Array.isArray(props)) {
      var map = {};
      props.forEach(function (row) {
        if (!row) return;
        if (Array.isArray(row)) map[row[0]] = row[1];
        else map[row.name || row.key] = row.value;
      });
      return map;
    }
    return props;
  }

  function variantId(item) {
    return String((item && (item.variant_id || item.id)) || '');
  }

  function isWizard(item) {
    return !!JOURNEYS[String(propsOf(item)._journey_id || '')];
  }

  function isGift(item) {
    return String(propsOf(item)._journey_gift || '') === '1';
  }

  function isPlan(item) {
    return isWizard(item) && !isGift(item);
  }

  function isForeverFood(item) {
    if (FOOD_PRODUCTS[String(item && item.product_id || '')]) return true;
    var handle = String(item && item.handle || '').toLowerCase();
    return handle === 'forever-food' || handle === 'forever-food-1' ||
      handle === 'forever-food-w3' || handle === 'forever-food-w4' || handle === 'forever-food-w5';
  }

  function codesOf(cart) {
    return ((cart && cart.discount_codes) || []).map(function (row) {
      return String((row && row.code) || '').trim();
    }).filter(Boolean);
  }

  function hasVariant(items, id) {
    return items.some(function (item) { return variantId(item) === id; });
  }

  function nextCodes(cart, hasPlan, hasFood) {
    var codes = codesOf(cart);
    if (!codes.length) return null;
    var items = cart.items || [];
    var kept = codes.filter(function (code) {
      var upper = code.toUpperCase();
      if (!hasPlan && !hasFood && BUYBOX_CODES[upper]) return false;
      if (!hasPlan) return !WIZARD_CODES[upper];
      if (SHARED_GIFT_CODES[upper]) {
        return items.some(function (item) { return GIFT_VARIANTS[variantId(item)]; });
      }
      if (GIFT_CODES[upper]) return hasVariant(items, GIFT_CODES[upper]);
      if (W3_GIFT_CODES[upper]) return items.some(function (item) { return W3_GIFT_VARIANTS[variantId(item)]; });
      return true;
    });
    if (kept.length === codes.length) return null;
    return kept.join(',');
  }

  function paint(cart) {
    var sections = cart && cart.sections;
    if (!sections) return;
    var drawer = document.getElementById('CartDrawer');
    if (drawer && sections['cart-drawer']) {
      var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var inner = parsed.querySelector('.drawer__inner');
      var target = document.querySelector('#CartDrawer .drawer__inner') || document.querySelector('.drawer__inner');
      if (inner && target) target.innerHTML = inner.innerHTML;
      var wrapper = document.querySelector('cart-drawer');
      if (wrapper) wrapper.classList.toggle('is-empty', cart.item_count === 0);
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var bubbleParsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var bubbleInner = bubbleParsed.querySelector('.shopify-section');
      if (bubbleInner) bubble.innerHTML = bubbleInner.innerHTML;
    }
    var main = document.getElementById('main-cart-items');
    if (main && main.dataset.id && sections[main.dataset.id]) {
      var mainParsed = new DOMParser().parseFromString(sections[main.dataset.id], 'text/html');
      var contents = mainParsed.querySelector('.js-contents');
      var live = main.querySelector('.js-contents');
      if (contents && live) live.innerHTML = contents.innerHTML;
    }
    var footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset.id && sections[footer.dataset.id]) {
      footer.classList.toggle('is-empty', cart.item_count === 0);
      var footerParsed = new DOMParser().parseFromString(sections[footer.dataset.id], 'text/html');
      var footerContents = footerParsed.querySelector('.js-contents');
      var footerLive = footer.querySelector('.js-contents');
      if (footerContents && footerLive) footerLive.innerHTML = footerContents.innerHTML;
    }
  }

  function sectionList() {
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    var main = document.getElementById('main-cart-items');
    if (main && main.dataset.id) ids.push(main.dataset.id);
    var footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset.id) ids.push(footer.dataset.id);
    return ids.join(',');
  }

  function enforce(cart) {
    if (!cart || !cart.items || busy) return Promise.resolve(cart);
    var wizard = cart.items.filter(isWizard);
    var hasPlan = wizard.some(isPlan);
    var hasFood = cart.items.some(isForeverFood);
    var updates = {};
    if (!hasPlan) {
      wizard.filter(isGift).forEach(function (item) { updates[item.key] = 0; });
    } else if (snapshot && snapshot.items) {
      cart.items.forEach(function (item) {
        if (!isGift(item)) return;
        var prev = snapshot.items.find(function (old) { return old.key === item.key; });
        if (prev && item.quantity !== prev.quantity && item.quantity !== 0) updates[item.key] = prev.quantity;
      });
    }
    if (!hasPlan && !hasFood) {
      cart.items.forEach(function (item) {
        if (BUYBOX_FREEBIES[variantId(item)]) updates[item.key] = 0;
      });
    }
    var discount = nextCodes(cart, hasPlan, hasFood);
    if (!Object.keys(updates).length && discount == null) {
      snapshot = cart;
      return Promise.resolve(cart);
    }
    var body = { sections: sectionList(), sections_url: window.location.pathname };
    if (Object.keys(updates).length) body.updates = updates;
    if (discount != null) body.discount = discount;
    busy = true;
    return originalFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) { return response.json(); }).then(function (next) {
      snapshot = next;
      paint(next);
      return next;
    }).catch(function () {
      return cart;
    }).finally(function () {
      busy = false;
    });
  }

  function cartFromResponse(response, added) {
    if (!added) return response.clone().json();
    // /cart/add.js returns only the new lines. A gift add would look like a cart with no food.
    return originalFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (next) {
      return next.json();
    });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var added = url.indexOf('/cart/add') !== -1;
    var watch = added || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1;
    return originalFetch.apply(this, arguments).then(function (response) {
      if (!watch || busy) return response;
      cartFromResponse(response, added).then(function (cart) {
        if (!cart || !cart.items) return;
        enforce(cart);
      }).catch(function () {});
      return response;
    });
  };

  originalFetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (response) { return response.json(); })
    .then(function (cart) { return enforce(cart); })
    .catch(function () {});
})();
